import React, { Component } from "react";
import AlertsList from "./AlertsList";
import { Row, Col } from "reactstrap";
import { MyButton } from "../../../Common/Forms/formsMiscItems";
import CommonModal from "../../../Common/CommonModal";
import AlertInfoArea from "../AlertInfoArea";
import { guid } from "../../../../utils/UUID";
import { languageService } from "../../../../Language/language.service";
import { themeService } from "../../../../theme/service/activeTheme.service";
import { ButtonStyle } from "../../../../style/basic/commonControls";

const defaultAlertInfo = {
  alertType: "Days before Expiry",
  expiryAlertDays: 0,
  overdueAlert: false,
  emailUserIds: [],
};
class AddMultiAlerts extends Component {
  constructor(props) {
    super(props);
    this.state = {
      workedAlertInfo: { ...defaultAlertInfo, emailUserIds: [] },
    };
    this.openAlertsModel = null;
    this.onChangeAlertEntry = this.onChangeAlertEntry.bind(this);
    this.onEditSelect = this.onEditSelect.bind(this);
    this.onDeleteSelect = this.onDeleteSelect.bind(this);
    this.onAddEditAlert = this.onAddEditAlert.bind(this);
  }
  onChangeAlertEntry(e, blur) {
    let id = e.target.value.id;
    if (!id) id = guid();
    let alertObj = { ...this.state.workedAlertInfo, ...e.target.value, id: id };
    this.setState({ workedAlertInfo: alertObj, message: null });
  }

  onEditSelect(alertObj) {
    this.openAlertsModel && this.openAlertsModel(true);
    this.setState({
      workedAlertInfo: alertObj,
      message: null,
    });
  }
  onDeleteSelect(alertId) {
    // remove alertObj from main array
    let alerts = [...this.props.alerts];
    let newAlerts = alerts.filter((item) => item.id !== alertId);
    this.onMainAlertArrayChange(newAlerts);
  }
  onAddEditAlert() {
    let alerts = [...this.props.alerts];
    let updatedAlert = this.state.workedAlertInfo;
    let emptyUserId = updatedAlert.emailUserIds && updatedAlert.emailUserIds.length > 0;
    let valid = emptyUserId;
    let msgList = {
      emptyUserId: languageService("No user selected"),
    };
    if (valid) {
      let alertIndex = alerts.findIndex((item) => item.id === updatedAlert.id);
      if (alertIndex !== -1) {
        alerts[alertIndex] = updatedAlert;
      } else {
        alerts.push(updatedAlert);
      }
      this.openAlertsModel(false);
      this.onMainAlertArrayChange(alerts);
    } else {
      this.setState({ message: msgList["emptyUserId"] });
    }
  }
  onMainAlertArrayChange(alertArray) {
    let newEvent = { target: { name: "alerts", value: alertArray } };
    this.props.changeHandler(newEvent);
    this.setState({
      workedAlertInfo: { ...defaultAlertInfo, emailUserIds: [], message: null },
    });
  }

  render() {
    return (
      <div>
        <CommonModal
          headerText={"Alert"}
          setModalOpener={(model) => (this.openAlertsModel = model)}
          disableDefaultfooterButtons={true}
          footerContent={
            <Col md={12}>
              <Row>
                <Col md={6}>
                  <div style={{ color: "#ca0505", fontSize: "12px", fontWeight: 600 }}>{this.state.message}</div>
                </Col>

                <Col md={3}>
                  <MyButton
                    type="button"
                    style={themeService(ButtonStyle.commonButton)}
                    onClick={(e) => {
                      this.onAddEditAlert();
                    }}
                  >
                    {languageService("Ok")}
                  </MyButton>
                </Col>

                <Col md={3}>
                  <MyButton
                    type="button"
                    style={themeService(ButtonStyle.commonButton)}
                    onClick={(e) => {
                      this.openAlertsModel(false);
                    }}
                  >
                    {languageService("Cancel")}
                  </MyButton>
                </Col>
              </Row>
            </Col>
          }
        >
          <AlertInfoArea
            alertUserList={this.props.alertUserList}
            noOverdueAlertCheckbox={true}
            changeHandler={this.onChangeAlertEntry}
            alertInfo={this.state.workedAlertInfo}
          />
        </CommonModal>
        <span
          style={{
            color: "var(--first)",
            cursor: "pointer",
            marginLeft: "10px",
            float: "right",
            paddingRight: "15px",
            paddingBottom: "10px",
          }}
          onClick={() => {
            this.openAlertsModel && this.openAlertsModel(true);
            this.setState({
              workedAlertInfo: { ...defaultAlertInfo },
            });
          }}
        >
          {languageService("Add Alert")} ...
        </span>

        {/* <MyButton
          onClick={(e) => {
            this.openAlertsModel && this.openAlertsModel(true);
            this.setState({
              workedAlertInfo: { ...defaultAlertInfo },
            });
          }}
          customStyle={{ marginBottom: "15px" }}
        >
          Add Alert
        </MyButton> */}
        <AlertsList
          userList={this.props.userList}
          testAlerts={this.props.alerts ? this.props.alerts : []}
          deleteAlert={this.onDeleteSelect}
          editAlert={this.onEditSelect}
        />
      </div>
    );
  }
}

export default AddMultiAlerts;



// WEBPACK FOOTER //
// ./src/components/SetupPage/GITestAssetTypes/AddAlerts/AddMultiAlerts.jsx